import React from 'react';
import { SortByOption } from '../types';

interface DashboardListHeaderProps {
    sortBy: SortByOption;
    handleSortByChange: (value: string) => void;
    sortAsc: boolean;
    setSortAsc: (asc: boolean) => void;
}

const DashboardListHeader: React.FC<DashboardListHeaderProps> = ({
    sortBy,
    handleSortByChange,
    sortAsc,
    setSortAsc
}) => {
    const handleHeaderClick = (column: SortByOption) => {
        if (sortBy === column) {
            setSortAsc(!sortAsc);
        } else {
            handleSortByChange(column);
        }
    };

    const renderSortIcon = (column: SortByOption) => {
        if (sortBy === column) {
            return <i className={`pi ${sortAsc ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down'}`}></i>;
        }
        return null;
    };

    return (
        <div className="instance-list-header">
            <div className="list-col header-col col-status" onClick={() => handleHeaderClick('sensorstatus')}>
                Sensor Status {renderSortIcon('sensorstatus')}
            </div>
            <div className="list-col header-col col-name" onClick={() => handleHeaderClick('name')}>
                Name {renderSortIcon('name')}
            </div>
            <div className="list-col header-col col-type" onClick={() => handleHeaderClick('type')}>
                Type {renderSortIcon('type')}
            </div>
            <div className="list-col header-col col-host" onClick={() => handleHeaderClick('host')}>
                Host {renderSortIcon('host')}
            </div>
            <div className="list-col header-col col-hosttype" style={{textAlign: 'center'}} title="Host Type (OS)" onClick={() => handleHeaderClick('hostType')}>
                OS {renderSortIcon('hostType')}
            </div>
            <div className="list-col header-col col-metrics-total-time" onClick={() => handleHeaderClick('totalTime')}>
                Total Time {renderSortIcon('totalTime')}
            </div>
            <div className="list-col header-col col-metrics-executions" onClick={() => handleHeaderClick('executions')}>
                Executions {renderSortIcon('executions')}
            </div>
            <div className="list-col header-col col-metrics-avg-time" onClick={() => handleHeaderClick('avgTime')}>
                Avg Time {renderSortIcon('avgTime')}
            </div>
            <div className="list-col header-col col-cpu" onClick={() => handleHeaderClick('cpu')}>
                CPU % {renderSortIcon('cpu')}
            </div>
            <div className="list-col header-col col-disk" onClick={() => handleHeaderClick('disk')}>
                Disk I/O % {renderSortIcon('disk')}
            </div>
            <div className="list-col header-col col-mem" onClick={() => handleHeaderClick('mem')}>
                Memory % {renderSortIcon('mem')}
            </div>
            <div className="list-col header-col col-alerts" onClick={() => handleHeaderClick('alerts')}>
                Alerts {renderSortIcon('alerts')}
            </div>
            <div className="list-col header-col col-changes" onClick={() => handleHeaderClick('changes')}>
                Changes {renderSortIcon('changes')}
            </div>
            <div className="list-col header-col col-custom" onClick={() => handleHeaderClick('custom')}>
                Custom {renderSortIcon('custom')}
            </div>
        </div>
    );
};

export default DashboardListHeader; 